<template>
  <div>
    <draggable v-model="activePage.pageItems"
               class="dragArea editor"
               group="formbuilder"
               handle=".handle"
               @input="onUpdatePage"
               @start="drag=true"
               @end="drag=false"
    >
      <v-expansion-panels v-for="(field, index) in activePage.pageItems" :key="field.id">
        <field-preview
          :control="field"
          :item-index="index"
          :page-index="selectedPage"
        />
      </v-expansion-panels>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FieldPreview from '@/components/questionnaires/fields/FieldPreview'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EditorArea',
  components: {
    draggable,
    FieldPreview
  },
  props: {
    selectedPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'workingPages'
    ]),
    activePage () {
      return this.workingPages[this.selectedPage]
    }
  },
  methods: {
    ...mapActions('Questionnaires', [
      'workingItemsUpdate'
    ]),
    onUpdatePage (newItems) {
      this.workingItemsUpdate({
        updatedItems: newItems,
        pageIndex: this.selectedPage
      })
    }
  }
}
</script>

<style>
  .editor {
    min-height: 50px;
  }
</style>
